import { FaCalculator, FaDumbbell, FaFire, FaPercentage, FaStar, FaUser, FaUserTag, FaWeight, FaWhatsapp } from "react-icons/fa";
import Navbar from "./Navbar";
import { IoCheckmarkCircleOutline } from "react-icons/io5";
import { IoMdCheckmarkCircle } from "react-icons/io";
import { LiaDumbbellSolid } from "react-icons/lia";
import { CiCalendarDate } from "react-icons/ci";
import { useEffect, useState } from "react";
import { db } from "../Firebase";
import Footer from "./Footer";
import { Link } from "react-router-dom";

export default function Home() {

    const list = [
        { icon: <LiaDumbbellSolid className="text-danger mb-3" size={40} />, number: "500+", title: "Clients Trained" },
        { icon: <FaWeight className="text-danger mb-3" size={40} />, number: "7000+", title: "KG's Weight Lost" },
        { icon: <FaUserTag className="text-danger mb-3" size={40} />, number: "95%", title: "Success Rate" },
        { icon: <CiCalendarDate className="text-danger mb-3" size={40} />, number: "15+", title: "Years Experience" },
    ]

    const tools = [
        { link: "/user/Bmi", icon: <FaCalculator />, title: "BMI Calculator", desc: "Check your Body Mass Index instantly.", color: "#22c55e" },
        { link: "/user/Calorie", icon: <FaFire />, title: "Calorie Calculator", desc: "Find out your daily calorie needs.", color: "#f97316" },
        { link: "/user/ProteinCalculator", icon: <FaDumbbell />, title: "Protein Calculator", desc: "Calculate your daily protein intake.", color: "#3b82f6" },
    ];

    const [pro, setpro] = useState([]);

    function fetchprograms() {
        db.collection("programs").onSnapshot((succ) => {
            setpro(succ.docs);
        })
    }

    useEffect(() => {
        fetchprograms()
    }, [])

    const testimonials = [
        { name: "Rahul Sharma", image: <FaUser size={20} />, review: "Lost 18kg in 5 months with Coach Harman. The personalized plan and accountability made all the difference.", result: "18 KG Lost" },
        { name: "Aman Verma", image: <FaUser size={20} />, review: "Built muscle and improved my strength significantly. Weekly check-ins kept me motivated.", result: "8 KG Muscle Gain" },
        { name: "Priya Kapoor", image: <FaUser size={20} />, review: "Amazing nutrition coaching. I finally learned how to eat properly without strict dieting.", result: "12 KG Lost" },
    ];

    const faqs = [
        { question: "How does online coaching work?", answer: "You'll receive customized workout plans, nutrition guidance, weekly check-ins and continuous support." },
        { question: "Do I need supplements?", answer: "No. Supplements are optional and only recommended when necessary." },
        { question: "How often will we connect?", answer: "Weekly check-ins are conducted to review progress and update plans." },
        { question: "Can beginners join?", answer: "Absolutely. Programs are customized for all fitness levels." },
        { question: "How long before I see results?", answer: "Most clients start noticing visible changes within 4-6 weeks." }
    ];

    return (
        <>
            <title>The Fitness Expert | Online Fitness Coach & Fat Loss Expert</title>
            <meta name="description" content="Transform your body with The Fitness Expert's personalized online fitness coaching. Get customized workout plans, nutrition guidance, fat loss, muscle building, body recomposition, and one-on-one coaching designed to help you achieve your fitness goals." />
            <meta name="keywords" content="The Fitness Expert, online fitness coach, personal trainer, online personal training, fat loss coach, muscle building coach, body transformation, nutrition coaching, fitness trainer India, online gym coach, weight loss program, muscle gain program, body recomposition, customized workout plans, online fitness consultation, fitness expert, health coach, strength training, lifestyle coaching" />
            <meta property="og:title" content="The Fitness Expert | Personalized Online Fitness Coaching" />
            <meta property="og:site_name" content="The Fitness Expert" />
            <meta property="og:url" content="https://thefitnessexpert.in/" />
            <meta property="og:description" content="Join The Fitness Expert and transform your body with customized workout plans, nutrition guidance, and expert online coaching for fat loss, muscle building, and overall fitness." />
            <meta property="og:image" content="logo.png"></meta>
            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@thefitnessexpert" />
            <meta name="twitter:description" content="Join The Fitness Expert and transform your body with customized workout plans, nutrition guidance, and expert online coaching for fat loss, muscle building, and overall fitness." />
            <meta name="twitter:app:country" content="India" />
            <Navbar />
            <section className="hero-section d-flex align-items-center text-white herooo">
                <div className="container text-center">
                    <h1 className="display-3 fw-bold">Transform Your Body With Personalized Online Coaching</h1>
                    <p className="lead mt-3">Custom workouts, nutrition guidance, accountability and results.</p>
                    <div className="mt-2">
                        <Link to="/user/Programs">
                            <button className="btn btn-danger me-3 mt-2">View Our Training Programs</button>
                        </Link>
                    </div>
                </div>
            </section>
            <section className="py-5">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-3 mb-2 col-12 d-flex justify-content-center align-items-center">
                            <img src="../images/coachh.jpeg" className="img-fluid rounded" style={{ maxHeight: "340px", width: "auto" }} alt="" />
                        </div>
                        <div className="col-md-4 mb-2 col-12 px-4">
                            <h4 className="text-danger fw-bold">About the coach ────</h4>
                            <p>
                                Helping busy professionals lose fat, gain muscle and build
                                confidence through sustainable coaching.
                            </p>
                            <ul className="list-unstyled">
                                <li>
                                    <IoMdCheckmarkCircle className="text-danger mb-1 me-2" size={16} />15+ Years Experience
                                </li>
                                <li>
                                    <IoMdCheckmarkCircle className="text-danger mb-1 me-2" size={16} />500+ Transformations
                                </li>
                                <li>
                                    <IoMdCheckmarkCircle className="text-danger mb-1 me-2" size={16} />Certified Fitness Coach
                                </li>
                                <li>
                                    <IoMdCheckmarkCircle className="text-danger mb-1 me-2" size={16} />Nutrition Specialist
                                </li>
                            </ul>
                        </div>
                        <div className="col-md-5 mb-2 col-12 row m-0">
                            {list.map((item, index) => (
                                <div className="col-md-6 col-6 mb-4" key={index}>
                                    <div className="card shadow h-100">
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                <div>{item.icon}</div>
                                                <div className="m-0 p-0">
                                                    <h5 className="p-0 m-0 fw-bold">{item.number}</h5>
                                                    <p>
                                                        {item.title}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-3 bg-light">
                <div className="container">
                    <div className="text-center mb-5">
                        <p className="text-danger fw-bold text-uppercase mb-2">Coaching Programs</p>
                        <h2 className="fw-bold text-dark">Programs Designed For Your Goals</h2>
                        <p className="text-dark">Personalized training, nutrition and support for long term results.</p>
                    </div>
                    <div className="row g-4">
                        {pro.slice(0, 4).map((row) => (
                            <div className="col-lg-3 col-md-6" key={row.id}>
                                <div className="card border-0 shadow-sm h-100 rounded-4 overflow-hidden">
                                    <div className="position-relative">
                                        <img src={row.data().img} alt={row.data().name} className="card-img-top carddimgtop" />
                                        <div className="image-overlay"></div>
                                    </div>
                                    <div className="card-body">
                                        <div className="bg-danger position-relative text-white rounded-circle d-flex align-items-center justify-content-center fs-4 mb-3 iconnn">
                                            {row.data().icon}
                                        </div>
                                        <h5 className="fw-bold text-dark">{row.data().name}</h5>
                                        <p className="text-muted small paraa">{row.data().desc}</p>
                                        <ul className="ps-3" style={{ height: 150 }}>
                                            {row.data().features?.map((feature, index) => (
                                                <li key={index} className="small mb-2">
                                                    {feature}
                                                </li>
                                            ))}
                                        </ul>
                                        <h6>
                                            <strong>Duration: {row.data().duration}</strong>
                                        </h6>
                                        <Link to="/user/Contact">
                                            <button className="btn btn-danger w-100 rounded-3">
                                                Apply Now
                                            </button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="d-flex align-items-center justify-content-center mt-3">
                        <Link to="/user/Programs">
                            <button className="btn btn-dark">View All Programs</button>
                        </Link>
                    </div>
                </div>
            </section>
            <section className="fitness-tools py-3">
                <div className="container">
                    <div className="text-center">
                        <p className="text-danger fw-bold text-uppercase mb-2">Free Fitness Tools</p>
                        <h2 className="fw-bold text-white">Calculate. Track. Improve.</h2>
                        <p className="text-secondary">Use our free tools to analyze your body and track your progress.</p>
                    </div>
                    <div className="row g-1 justify-content-center">
                        {tools.map((tool, index) => (
                            <div className="col-lg-4 col-4" key={index}>
                                <div className="tool-card text-center">
                                    <div className="tool-icon" style={{ color: tool.color }}>
                                        {tool.icon}
                                    </div>
                                    <h5 className="text-white fw-bold mt-3">{tool.title}</h5>
                                    <p className="text-secondary small">{tool.desc}</p>
                                    <Link to={tool.link}>
                                        <button className="btn btn-outline-light px-2">Calculate Now</button>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className="py-4 bg-light">
                <div className="container">
                    <div className="text-center mb-5">
                        <p className="text-danger fw-bold text-uppercase">Testimonials</p>
                        <h2 className="fw-bold text-dark">Real Clients. Real Results.</h2>
                        <p className="text-muted">Success stories from people who transformed their lives.</p>
                    </div>
                    <div className="row g-4">
                        {testimonials.map((item, index) => (
                            <div className="col-lg-4 col-md-6 col-12" key={index}>
                                <div className="testimonial-card-light">
                                    <div className="d-flex align-items-center mb-3">
                                        <div className="testimonial-img bg-primary-subtle">{item.image}</div>
                                        <div className="ms-3">
                                            <h5 className="mb-1 text-dark">{item.name}</h5>
                                            <small className="text-success fw-semibold">{item.result}</small>
                                        </div>
                                    </div>
                                    <div className="mb-3">
                                        {[1, 2, 3, 4, 5].map((star) => (
                                            <FaStar key={star} className="text-warning me-1" />
                                        ))}
                                    </div>
                                    <p className="text-muted mb-0">
                                        "{item.review}"
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <section className="py-3">
                <div className="container">
                    <div className="text-center mb-5">
                        <p className="text-danger fw-bold text-uppercase mb-2">Frequently Asked Questions</p>
                        <h2 className="fw-bold text-dark">Got Questions?</h2>
                        <p className="text-muted">Everything you need to know before starting your fitness journey.</p>
                    </div>
                    <div className="row">
                        {faqs.map((faq, index) => (
                            <div className="col-lg-6 col-md-6 col-12 mb-4" key={index}>
                                <div className="accordion" id={`faqAccordion${index}`}>
                                    <div className="accordion-item faq-card">
                                        <h2 className="accordion-header">
                                            <button className={`accordion-button ${index !== 0 ? "collapsed" : ""}`} type="button" data-bs-toggle="collapse" data-bs-target={`#faq${index}`}>
                                                {faq.question}
                                            </button>
                                        </h2>
                                        <div id={`faq${index}`} className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}>
                                            <div className="accordion-body">{faq.answer}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <div className="position-fixed bottom-0 end-0 p-3 z-3">
                <button className="fixed-join-btn text-light fw-bold px-3 py-2 shadow rounded-pill bgcolor"
                    onClick={() =>
                        window.open("https://wa.me/919876857579?text=Hello%20Harman%20Sir%20👋%0A%0AI%20visited%20your%20website%20and%20I'm%20interested%20in%20your%20fitness%20coaching%20programs.", "_blank"
                        )}>
                    <FaWhatsapp size={24} />
                </button>
            </div>
            <Footer />
        </>
    )
}